import { Order } from '../Table/types';
import { Columns, HeadCell } from './types';

export const headCells: HeadCell[] = [
  { id: Columns.FullName, label: 'Full name', order: Order.Asc },
  { id: Columns.Status, label: 'Status', order: Order.Asc },
];
